// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.caller-row-ongoing-call-info {
   
  
  .caller-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* margin-bottom: 10px; */

    &:last-child {
      margin-bottom: 0;
    }

    .caller-row-caller-name {
      font-family: Graphik;
      font-size: 16px;
      font-weight: 500;
      line-height: 16px;
      text-align: left;
      padding: 20px;
    }

    .caller-row-call-details {
      display: flex;
      align-items: center;
      /* padding: 20px 70px 0px 0px; */
      padding: 20px;

      /* .caller-row-rec {
        background-color: red;
        color: white;
        padding: 0 5px;
        margin-right: 10px;
        border-radius: 3px;
      } */

      .caller-row-timer {
          font-family: Graphik;
          font-size: 8px;
          font-weight: 400;
          line-height: 8.8px;
          text-align: left;
          color: #BFBFBF;
          padding-left: 10px;
          
      }
    }

    .caller-row-icon {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }

    
  }
}

@media (max-width: 600px) {
  .caller-row-ongoing-call-info {
    .caller-row {
      flex-direction: column;
      align-items: flex-start;

      .caller-row-call-details {
        margin-top: 5px;
      }
    }
  }
}

.caller-row-info {
  font-family: Graphik;
font-size: 12px;
font-weight: 400;
line-height: 13.2px;
text-align: left;
margin-left: 20px;
}

.parcel-item {
  margin-left: 20px;
}

.teams-icon-meeting {
  padding-left: 70px;
  padding-top: 20px;
}
.call-img-sec {
  padding-top: 15px;
  padding-bottom: 20px;
}
.arrow-icon-call {
  padding-right: 10px;
  margin-top: 7px;
}

.stop-image {
  height: 30px;
  width: 30px;
  background-color: transparent;
  border: none;
  margin-left: 20px;
}

.stop-image-icon {
  height: 30px;
  width: 30px;
  border: none;
  
}`, "",{"version":3,"sources":["webpack://./src/CustomerCare/CallHistory.css"],"names":[],"mappings":"AAAA;;;EAGE;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;;IAEzB;MACE,gBAAgB;IAClB;;IAEA;MACE,oBAAoB;MACpB,eAAe;MACf,gBAAgB;MAChB,iBAAiB;MACjB,gBAAgB;MAChB,aAAa;IACf;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,gCAAgC;MAChC,aAAa;;MAEb;;;;;;SAMG;;MAEH;UACI,oBAAoB;UACpB,cAAc;UACd,gBAAgB;UAChB,kBAAkB;UAClB,gBAAgB;UAChB,cAAc;UACd,kBAAkB;;MAEtB;IACF;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,kBAAkB;IACpB;;;EAGF;AACF;;AAEA;EACE;IACE;MACE,sBAAsB;MACtB,uBAAuB;;MAEvB;QACE,eAAe;MACjB;IACF;EACF;AACF;;AAEA;EACE,oBAAoB;AACtB,eAAe;AACf,gBAAgB;AAChB,mBAAmB;AACnB,gBAAgB;AAChB,iBAAiB;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;;AAEd","sourcesContent":[".caller-row-ongoing-call-info {\n   \n  \n  .caller-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    /* margin-bottom: 10px; */\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    .caller-row-caller-name {\n      font-family: Graphik;\n      font-size: 16px;\n      font-weight: 500;\n      line-height: 16px;\n      text-align: left;\n      padding: 20px;\n    }\n\n    .caller-row-call-details {\n      display: flex;\n      align-items: center;\n      /* padding: 20px 70px 0px 0px; */\n      padding: 20px;\n\n      /* .caller-row-rec {\n        background-color: red;\n        color: white;\n        padding: 0 5px;\n        margin-right: 10px;\n        border-radius: 3px;\n      } */\n\n      .caller-row-timer {\n          font-family: Graphik;\n          font-size: 8px;\n          font-weight: 400;\n          line-height: 8.8px;\n          text-align: left;\n          color: #BFBFBF;\n          padding-left: 10px;\n          \n      }\n    }\n\n    .caller-row-icon {\n      width: 20px;\n      height: 20px;\n      margin-right: 10px;\n    }\n\n    \n  }\n}\n\n@media (max-width: 600px) {\n  .caller-row-ongoing-call-info {\n    .caller-row {\n      flex-direction: column;\n      align-items: flex-start;\n\n      .caller-row-call-details {\n        margin-top: 5px;\n      }\n    }\n  }\n}\n\n.caller-row-info {\n  font-family: Graphik;\nfont-size: 12px;\nfont-weight: 400;\nline-height: 13.2px;\ntext-align: left;\nmargin-left: 20px;\n}\n\n.parcel-item {\n  margin-left: 20px;\n}\n\n.teams-icon-meeting {\n  padding-left: 70px;\n  padding-top: 20px;\n}\n.call-img-sec {\n  padding-top: 15px;\n  padding-bottom: 20px;\n}\n.arrow-icon-call {\n  padding-right: 10px;\n  margin-top: 7px;\n}\n\n.stop-image {\n  height: 30px;\n  width: 30px;\n  background-color: transparent;\n  border: none;\n  margin-left: 20px;\n}\n\n.stop-image-icon {\n  height: 30px;\n  width: 30px;\n  border: none;\n  \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
